function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["aria-label", "children", "className", "disabled", "icon", "iconOnRight", "minor", "onClick", "variant", "withoutIcon"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect, useRef } from "react";
import { BUTTON_VARIANT, Button, buttonDefaultProps, buttonTypes } from "#library/components/Button";
import IconArrowDown from "#library/assets/icons/jds_arrowDown.svg";
import IconMoreActions from "#library/assets/icons/jds_moreActions.svg";
import { useDropdown } from "#library/components/Dropdown/components/Provider";
import { hideDropdownMenu, setTriggerButton, showDropdownMenu } from "#library/components/Dropdown/Dropdown.actions";
export var TriggerButton = function TriggerButton(_ref) {
  var ariaLabel = _ref["aria-label"],
    children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    icon = _ref.icon,
    iconOnRight = _ref.iconOnRight,
    minor = _ref.minor,
    onClick = _ref.onClick,
    variant = _ref.variant,
    withoutIcon = _ref.withoutIcon,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useDropdown = useDropdown(),
    state = _useDropdown.state,
    dispatch = _useDropdown.dispatch;
  var triggerRef = useRef();
  useEffect(function () {
    var triggerButton = triggerRef.current;
    dispatch(setTriggerButton(triggerButton));
  }, [dispatch]);
  var toggleDropdownMenu = function toggleDropdownMenu(event) {
    if (disabled) return;
    onClick(event);
    if (state.isDropdownMenuVisible) {
      dispatch(hideDropdownMenu());
    } else {
      dispatch(showDropdownMenu());
    }
  };
  if (!children) {
    return /*#__PURE__*/React.createElement(Button, _extends({}, restProps, {
      "aria-expanded": state.isDropdownMenuVisible,
      "aria-haspopup": "true",
      "aria-label": ariaLabel,
      className: className,
      disabled: disabled,
      icon: IconMoreActions,
      minor: minor !== null && minor !== void 0 ? minor : true,
      onClick: function onClick(event) {
        toggleDropdownMenu(event);
      },
      ref: triggerRef,
      variant: variant !== null && variant !== void 0 ? variant : BUTTON_VARIANT.NAKED
    }));
  }
  return /*#__PURE__*/React.createElement(Button, _extends({}, restProps, {
    "aria-expanded": state.isDropdownMenuVisible,
    "aria-haspopup": "true",
    className: className,
    disabled: disabled,
    icon: icon || IconArrowDown,
    iconOnRight: iconOnRight,
    minor: minor,
    onClick: function onClick(event) {
      toggleDropdownMenu(event);
    },
    ref: triggerRef
  }), children);
};
export var defaultProps = _objectSpread(_objectSpread({}, buttonDefaultProps), {}, {
  "aria-label": "Dropdown button",
  iconOnRight: true,
  minor: false,
  onClick: function onClick() {}
});
TriggerButton.defaultProps = defaultProps;
TriggerButton.propTypes = buttonTypes;